import * as React from 'react';
import upload from '@/server/upload';
import * as queryString from 'query-string';
import ViewsAndUpload from '@/pages/components/common/imgs/viewsAndUpload';
import config from '@/server/config';
import request from '@/server/request';

import store from '@/redux/index';
import { types } from '@/redux/imgs/viewsAndUpload';
const Toast = require('react-toast-mobile');

export default class AuthEnterpriseStep2 extends React.Component<any, any> {
    public constructor(props: any) {
        super(props);
        const query = queryString.parse(this.props.location.search);
        this.state = {
            authType: query.authtype ? `${query.authtype}` : 0,
            init: query.init ? `${query.init}` : 0,
            companyBank: [
                {
                    bank: "",
                    bankAccountNumber: "",
                    phone: "",
                    address: "",
                    type: 0
                }
            ], // 发票信息
            companyAddAccount: {
                bank: '',
                bankAccountNumber: '',
                type: 1
            }, // 退款银行
            threeCredentialType: '是', // 是否三证合一
            threeCredential: '', // 三证合一
            licence: '', // 营业执照
            organizationCodeCertificate: '', // 组织机构代码
            taxEnrolCertificate: '', // 税务登记证
            invoiceInfo: '', // 开票资料
            authorization: '', // 授权书
        };
    }
    public componentDidMount() {
        // 是否为重新认证
        if(this.state.authType === '1' || this.state.init === '1') {
            this.getData();
        } else {
            // 获取用户id，用于判断是否切换用户
            this.getUserInfo();
            // // 查看本地是否已经存储数据
            // const storage = (window as any).localStorage;
            // const storageData = storage.getItem('enterpriseStep2');
            // if(storageData) {
            //     const storageDataObj = JSON.parse(storageData);
            //     this.setState({...storageDataObj});
            // }
        }
        (document as any).documentElement.addEventListener("focusout",function(){
            (document as any).documentElement.scrollTop = 0;
            window.scrollTo(0,0);
         });
    }
    public render() {
        const state = this.state;
        return (
            <div>
                <p className="company-title">开票信息 <span onClick={() => this.addInvoiceItem()}>添加</span></p>
                {
                    state.companyBank.map((v: any, k: number) => {
                        return (
                            <div className="invoince-list" key={`invoinceItem${k}`}>
                                <ul className="company">
                                    <li>
                                        <div className="company-tit">
                                            <b>*</b>
                                            <p>开户银行</p>
                                        </div>
                                        <input type="text" className="textmarket" placeholder="请输入开户银行" value={v.bank} onChange={(e: any) => this.inputInvoince('bank', e, k)}/>
                                    </li>
                                    <li>
                                        <div className="company-tit">
                                            <b>*</b>
                                            <p>银行账号</p>
                                        </div>
                                        <input type="text" className="textmarket" placeholder="请输入银行账号" value={v.bankAccountNumber} onChange={(e: any) => this.inputInvoince('bankAccountNumber', e, k)}/>
                                    </li>
                                    <li>
                                        <div className="company-tit">
                                            <b>*</b>
                                            <p>联系电话</p>
                                        </div>
                                        <input type="text" className="textmarket" placeholder="请输入联系电话" value={v.phone} onChange={(e: any) => this.inputInvoince('phone', e, k)}/>
                                    </li>
                                    <li>
                                        <div className="company-tit">
                                            <b>*</b>
                                            <p>公司地址</p>
                                        </div>
                                        <input type="text" className="textmarket" placeholder="请输入公司地址" value={v.address} onChange={(e: any) => this.inputInvoince('address', e, k)} />
                                    </li>
                                </ul>
                                {
                                    k > 0 ?
                                    <p className="invoice-item-delete" onClick={() => this.deleteInvoiceItem(k)}>删除</p>
                                    : null
                                }
                            </div>
                        )
                    })
                }
                <p className="company-title">退款信息</p>
                <ul className="company">
                    <li>
                        <div className="company-tit">
                            <b>*</b>
                            <p>退款银行</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入退款银行" value={state.companyAddAccount.bank} onChange={(e: any) => this.inputRefundBank('bank', e)}/>
                    </li>
                    <li>
                        <div className="company-tit">
                            <b>*</b>
                            <p>退款银行账号</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入退款银行账号" value={state.companyAddAccount.bankAccountNumber} onChange={(e: any) => this.inputRefundBank('bankAccountNumber', e)}/>
                    </li>
                </ul>
                <p className="company-title">附件信息</p>
                <ul className="company">
                    <li className="picker-btn">
                        <select value={state.threeCredentialType} onChange={(e: any) => this.pickerSelectAction(e)}>
                            <option value="是">是</option>
                            <option value="否">否</option>
                        </select>
                        <div className="company-tit"><b>*</b><p>是否三证合一</p></div>
                        <div className="camera">
                            <div>
                                <span>{state.threeCredentialType}</span>
                                <img src={require('../../../assets/images/choose.png')} className="chooseImg" />
                            </div>
                        </div>
                    </li>
                    {
                        state.threeCredentialType === '是' ? 
                        <li>
                            <div className="company-tit">
                                <b>*</b>
                                <p>三证合一</p>
                            </div>
                            <div className="camera">
                                <div onClick={() => this.viewsBigImgs(0)}>
                                {
                                    state.threeCredential !== '' ?
                                    <img src={require('../../../assets/images/choose.png')} className="chooseImg" />
                                    : 
                                    <a href="javascript:;" className="file">
                                        <img src={require('../../../assets/images/camera.png')} className="cameraImg" />
                                        <input type="file" name="file" accept="image/*" onChange={(e: any) => this.uploadAction(0, e)}/>
                                    </a>  
                                } 
                                </div>
                            </div>
                        </li> : null
                    }
                    {
                        state.threeCredentialType === '否' ? 
                        <li>
                            <div className="company-tit">
                                <b>*</b>
                                <p>营业执照</p>
                            </div>
                            <div className="camera">
                                <div onClick={() => this.viewsBigImgs(1)}>
                                {
                                    state.licence !== '' ?
                                    <img src={require('../../../assets/images/choose.png')} className="chooseImg" />
                                    : 
                                    <a href="javascript:;" className="file">
                                        <img src={require('../../../assets/images/camera.png')} className="cameraImg" />
                                        <input type="file" name="file" accept="image/*" onChange={(e: any) => this.uploadAction(1, e)}/>
                                    </a>  
                                }
                                </div>
                            </div>
                        </li> : null
                    }
                    {
                        state.threeCredentialType === '否' ? 
                        <li>
                            <div className="company-tit">
                                <b>*</b>
                                <p>组织机构代码证</p>
                            </div>
                            <div className="camera">
                                <div onClick={() => this.viewsBigImgs(2)}>
                                {
                                    state.organizationCodeCertificate !== '' ?
                                    <img src={require('../../../assets/images/choose.png')} className="chooseImg" />
                                    : 
                                    <a href="javascript:;" className="file">
                                        <img src={require('../../../assets/images/camera.png')} className="cameraImg" />
                                        <input type="file" name="file" accept="image/*" onChange={(e: any) => this.uploadAction(2, e)}/>
                                    </a>  
                                }
                                </div>
                            </div>
                        </li> : null
                    }
                    {
                        state.threeCredentialType === '否' ? 
                        <li>
                            <div className="company-tit">
                                <b>*</b>
                                <p>税务登记证</p>
                            </div>
                            <div className="camera">
                                <div onClick={() => this.viewsBigImgs(3)}>
                                {
                                    state.taxEnrolCertificate !== '' ?
                                    <img src={require('../../../assets/images/choose.png')} className="chooseImg" />
                                    : 
                                    <a href="javascript:;" className="file">
                                        <img src={require('../../../assets/images/camera.png')} className="cameraImg" />
                                        <input type="file" name="file" accept="image/*" onChange={(e: any) => this.uploadAction(3, e)}/>
                                    </a>  
                                }
                                </div>
                            </div>
                        </li> : null
                    }
                    <li>
                        <div className="company-tit">
                            <b>*</b>
                            <p>开票资料</p>
                        </div>
                        <div className="camera">
                            <div onClick={() => this.viewsBigImgs(4)}>
                            {
                                state.invoiceInfo !== '' ?
                                <img src={require('../../../assets/images/choose.png')} className="chooseImg" />
                                : 
                                <a href="javascript:;" className="file">
                                    <img src={require('../../../assets/images/camera.png')} className="cameraImg" />
                                    <input type="file" name="file" accept="image/*" onChange={(e: any) => this.uploadAction(4, e)}/>
                                </a>  
                            }
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="company-tit">
                            <b>*</b>
                            <p>授权书</p>
                        </div>
                        <div className="camera">
                            <div onClick={() => this.viewsBigImgs(5)}>
                            {
                                state.authorization !== '' ?
                                <img src={require('../../../assets/images/choose.png')} className="chooseImg" />
                                : 
                                <a href="javascript:;" className="file">
                                    <img src={require('../../../assets/images/camera.png')} className="cameraImg" />
                                    <input type="file" name="file" accept="image/*" onChange={(e: any) => this.uploadAction(5, e)}/>
                                </a>  
                            }
                            </div>
                        </div>
                    </li>
                </ul>
                <button className="personal-btn" disabled={!this.validatyForm()} onClick={() => this.nextAction()}>下一步</button>
                <ViewsAndUpload />
            </div>
        )
    }
    // 获取数据
    private async getData() {
        const r = await request({
            url: `${config.API}member/company/info`
        });
        if(r.code === 1) {
            const obj = r.obj.companyInfo;
            this.setState({
                companyBank: obj.companyBanks,
                companyAddAccount: obj.refundBank,
                threeCredentialType: obj.threeCredentialType == '1' ? '是' : '否',
                threeCredential: obj.threeCredential || '',
                licence: obj.licence || '',
                organizationCodeCertificate: obj.organizationCodeCertificate || '',
                taxEnrolCertificate: obj.taxEnrolCertificate || '',
                invoiceInfo: obj.invoiceInfo || '',
                authorization: obj.authorization || ''
            });
        }
    }
    // 新增一条发票信息
    private addInvoiceItem() {
        let invoice = this.state.companyBank;
        invoice.push({
            bank: "",
            bankAccountNumber: "",
            phone: "",
            address: "",
            type: "0"
        });
        this.setState({companyBank: invoice});
    }
    /**
     * 删除一条发票信息
     * @param index 索引
     */
    private deleteInvoiceItem(index: number) {
        let invoice = this.state.companyBank;
        invoice.splice(index, 1);
        this.setState({companyBank: invoice});
    }
    /**
     * 输入发票银行信息
     * @param stateName 状态名称
     * @param e 事件对象
     * @param index 发票银行对应索引
     */
    private inputInvoince(stateName: string, e: any, index: number) {
        let invoince = this.state.companyBank;
        invoince[index][stateName] = e.target.value;
        this.setState({companyBank: invoince});
    }
    /**
     * 输入退款银行信息
     * @param stateName 状态名称
     * @param e 事件对象
     */
    private inputRefundBank(stateName: string, e: any) {
        let refundBank = this.state.companyAddAccount;
        refundBank[stateName] = e.target.value;
        this.setState({companyAddAccount: refundBank});
    }
    /**
     * 是否三证合一
     * @parma e [输入事件]
     */
    private pickerSelectAction(e: any) {
        if(this.state.threeCredentialType === e.currentTarget.value) {
            return;
        }
        this.setState({threeCredentialType: e.currentTarget.value});
    }
    /**
     * 上传图片
     * @param type 0:threeCredential 1:licence 2:organizationCodeCertificate 3:taxEnrolCertificate 4:invoiceInfo 5:authorization
     * @param e 
     */
    private async uploadAction(type: number, e: any) {
        const r = await upload(e);
        if(r.code === 1) {
            switch(type) {
                case 0:
                    this.setState({threeCredential: r.obj});
                break;
                case 1:
                    this.setState({licence: r.obj});
                break;
                case 2:
                    this.setState({organizationCodeCertificate: r.obj});
                break;
                case 3:
                    this.setState({taxEnrolCertificate: r.obj});
                break;
                case 4:
                    this.setState({invoiceInfo: r.obj});
                break;
                case 5:
                    this.setState({authorization: r.obj});
                break;
                default:
                break;
            }
        }
    }
    /**
     * 查看大图
     * @param type 0:threeCredential 1:licence 2:organizationCodeCertificate 3:taxEnrolCertificate 4:invoiceInfo 5:authorization
     */
    private viewsBigImgs(index: number) {
        const ids = [
            this.state.threeCredential,
            this.state.licence,
            this.state.organizationCodeCertificate,
            this.state.taxEnrolCertificate,
            this.state.invoiceInfo,
            this.state.authorization
        ];
        if(!ids[index]) {
            return;
        }
        store.dispatch({
            type: types.VIEWSANDUPLOAD_SHOW,
            data: {
                onUpload: (src: string) => {
                    switch(index) {
                        case 0:
                            this.setState({threeCredential: src});
                        break;
                        case 1:
                            this.setState({licence: src});
                        break;
                        case 2:
                            this.setState({organizationCodeCertificate: src});
                        break;
                        case 3:
                            this.setState({taxEnrolCertificate: src});
                        break;
                        case 4:
                            this.setState({invoiceInfo: src});
                        break;
                        case 5:
                            this.setState({authorization: src});
                        break;
                        default:
                        break;
                    }
                },
                src: config.API + 'image/download/crmAnnex?imgId=' + ids[index]
            }
        });
    }
    // 验证表单
    private validatyForm(): boolean {
        const states = this.state;
        let companyOk = true;
        for(let i=0,l=states.companyBank.length; i<l; i++) {
            if(states.companyBank[i].bank === '' ||
                states.companyBank[i].bankAccountNumber === '' ||
                states.companyBank[i].phone === '' ||
                states.companyBank[i].address === ''
            ) {
                companyOk = false;
                break;
            }
        }
        return companyOk && states.companyAddAccount.bank !== '' && states.companyAddAccount.bankAccountNumber !== ''
        && (states.threeCredentialType === '是' ? states.threeCredential !== '' : (
            states.licence !== '' && states.organizationCodeCertificate !== '' && states.taxEnrolCertificate !== ''
        )) && states.invoiceInfo !== '' && states.authorization !== '';
    }
    // 下一步
    private nextAction() {
        const states = this.state;
        let message = '';
        for(let i=0,l=states.companyBank.length; i<l; i++) {
            if(states.companyBank[i].bank === '') {
                message = `请填写第${i+1}个开票信息开户银行`;
                break;
            } 
            if(states.companyBank[i].bankAccountNumber === '') {
                message = `请填写第${i+1}个开票信息银行账号`;
                break;
            }
            if(states.companyBank[i].phone === '') {
                message = `请填写第${i+1}个开票信息联系电话`;
                break;
            }
            if(states.companyBank[i].address === '') {
                message = `请填写第${i+1}个开票信息公司地址`;
                break;
            }
        }
        if(message) {
            return Toast.T.notify(message);
        }
        if(states.companyAddAccount.bank === '') {
            return Toast.T.notify('请填写退款银行');
        }
        if(states.companyAddAccount.bankAccountNumber === '') {
            return Toast.T.notify('请填写退款银行账号');
        }
        if(states.threeCredentialType === '是') {
            if(states.threeCredential === '') {
                return Toast.T.notify('请上传三证合一');
            }
        } else {
            if(states.licence === '') {
                return Toast.T.notify('请上传营业执照');
            } else if(states.organizationCodeCertificate === '') {
                return Toast.T.notify('请上传组织结构代码');
            } else if(states.taxEnrolCertificate === '') {
                return Toast.T.notify('请上传税务登记证');
            }
        }
        if(states.invoiceInfo === '') {
            return Toast.T.notify('请上传开票资料');
        }
        if(states.authorization === '') {
            return Toast.T.notify('请上传授权书');
        }
        // 先把数据保存到本地，防止退出页面下次进来需要重新填写
        const string = JSON.stringify(this.state);
        const storage = (window as any).localStorage;

        // 如果是重新认证，先把数据保存到本地，方便统一提交
        if(this.state.authType === '1') {
            storage.setItem('enterpriseStepTemp2', string);
            this.props.history.push('/authentication/step3?authtype=1');
        } 
        else if(this.state.init === '1') {
            storage.setItem('enterpriseStep2', string);
            this.props.history.push('/authentication/step3?init=1');
        }
        // 否则，把数据保存到本地，下次重新打开默认显示数据
        else {
            storage.setItem('enterpriseStep2', string);
            this.props.history.push('/authentication/step3');
        }
    }
    private async getUserInfo() {
        const r = await request({
            url: `${config.WAPAPI}safety/account/get`
        });
        // 查看本地是否已经存储数据
        const storage = (window as any).localStorage;
        const storageData = storage.getItem('enterpriseStep2');
        this.setState({userId: r.obj.id});
        if(!storageData) return;
        const storageDataObj = JSON.parse(storageData);
        const localUserId = storageData ? storageDataObj.userId : null;
        // 如果之前没有用户填写或者有并且市同一用户
        if(!localUserId || r.obj.id == localUserId) { 
            this.setState({...storageDataObj});
        }
    }
}